(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["event-contact-v2"] && !window.DesignMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function(){
    const submitFormBtn = document.querySelector('.event-contact .event_contact_form [data-form-submit]');
    if(submitFormBtn){
      submitFormBtn.addEventListener('click',function(e){
        e.preventDefault();
        const inquiryForm = document.querySelector('.event-contact .event_contact_form');
        validateForm(inquiryForm);
      });
    }
  });

  function validateForm(form){
    if(!form) return;
    const requiredFormField = [...form.querySelectorAll('input[required]')];
    let errorCount = 0;
    if(requiredFormField.length){
      requiredFormField.forEach(field => {
        const fieldValue = field.value.trim();
        const fieldType = field.getAttribute('type');
        field.closest('.field').classList.remove('error-active');
        if(!fieldValue.length){
          field.closest('.field').classList.add('error-active');
          errorCount += 1;
        }else if(fieldType == 'email'){
          const isValidEmail = validateEmail(field.value.trim(),field);
          if(!isValidEmail) errorCount += 1;
        }
      });
    }
    if(errorCount === 0){
     formSubmit(form);
    }else{
      return false;
    }
  }

  function validateEmail(email,field) {
    let mailRegularExpresion = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    if (mailRegularExpresion) return true;    
    field.closest('.field').classList.add('error-active');
  }

  function formSubmit(form){
    if(!form) return;
    const actionURL = form.getAttribute('action');
    if(!actionURL) return;
    
    const formData = new FormData(form);

    const dataSendToHook = async () => {
      let formDataObject = {
        method: 'POST',
        headers: { "Accept": "application/json" },
        body: formData
      };
      const response = await fetch(actionURL, formDataObject);
      if (!response.ok) {
        console.log('%cHTTP error! status:','color: red; font-size: 14px; font-weight: 700', response.status);
        console.log('%cSomething went wrong, please refresh the page and try again..!!','color: red; font-size: 12px; font-weight: 700');
        return;
      }
      const data = await response.json();
      form.reset();
      if(form.querySelector('.contact__button')) form.querySelector('.contact__button').classList.add('hidden');
      if(form.querySelector('.success-msg')) form.querySelector('.success-msg').classList.remove('hidden');
      console.log('%cForm submited success >>','color: green; font-size: 12px; font-weight: 700', data);
    }
    dataSendToHook();
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-contact"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function(){
    const submitFormBtn = document.querySelector('.event-contact .event_contact_form [data-form-submit]');
    if(submitFormBtn){
      submitFormBtn.addEventListener('click',function(e){
        e.preventDefault();
        const inquiryForm = document.querySelector('.event-contact .event_contact_form');
        validateForm(inquiryForm);
      });
    }
  });

  function validateForm(form){
    if(!form) return;
    const requiredFormField = [...form.querySelectorAll('input[required]')];
    let errorCount = 0;
    if(requiredFormField.length){
      requiredFormField.forEach(field => {
        const fieldValue = field.value.trim();
        const fieldType = field.getAttribute('type');
        field.closest('.field').classList.remove('error-active');
        if(!fieldValue.length){
          field.closest('.field').classList.add('error-active');
          errorCount += 1;
        }else if(fieldType == 'email'){
          const isValidEmail = validateEmail(field.value.trim(),field);
          if(!isValidEmail) errorCount += 1;
        }
      });
    }
    if(errorCount === 0){
     formSubmit(form);
    }else{
      return false;
    }
  }

  function validateEmail(email,field) {
    let mailRegularExpresion = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    if (mailRegularExpresion) return true;    
    field.closest('.field').classList.add('error-active');
  }

  function formSubmit(form){
    if(!form) return;
    const actionURL = form.getAttribute('action');
    if(!actionURL) return;
    
    const formData = new FormData(form);

    const dataSendToHook = async () => {
      let formDataObject = {
        method: 'POST',
        headers: { "Accept": "application/json" },
        body: formData
      };
      const response = await fetch(actionURL, formDataObject);
      if (!response.ok) {
        console.log('%cHTTP error! status:','color: red; font-size: 14px; font-weight: 700', response.status);
        console.log('%cSomething went wrong, please refresh the page and try again..!!','color: red; font-size: 12px; font-weight: 700');
        return;
      }
      const data = await response.json();
      form.reset();
      if(form.querySelector('.contact__button')) form.querySelector('.contact__button').classList.add('hidden');
      if(form.querySelector('.success-msg')) form.querySelector('.success-msg').classList.remove('hidden');
      console.log('%cForm submited success >>','color: green; font-size: 12px; font-weight: 700', data);
    }
    dataSendToHook();
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const heroSectionEle = document.querySelector('.home-hero'); // for parallex animation effect

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(heroSectionEle) heroSectionEle.classList.add('active');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(heroSectionEle) heroSectionEle.classList.add('active');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if(heroSectionEle) heroSectionEle.classList.remove('active');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  
document.addEventListener("DOMContentLoaded", function() {

  const form = document.querySelector('#create_customer');
  if(form){
    
    //login form submit
    const submitBtn = form.querySelector('[data-form-submit]');
    if(submitBtn){
      submitBtn.addEventListener('click', function(evt){
        evt.preventDefault();
        validateForm(form);
      });
    }

    //show-hide password text
    const passToggleBtn = form.querySelector('[data-toggle-password]');
    if(passToggleBtn){
      passToggleBtn.addEventListener('click', function(evt){
        evt.preventDefault();
        if(evt.target.closest('[data-password-field]')){
          evt.target.closest('[data-password-field]').classList.toggle('pass-show');  
          const inputField = evt.target.closest('[data-password-field]').querySelector('input[name="customer[password]"]');
          if (inputField.getAttribute("type") == "password") {
            inputField.setAttribute("type", "text");
          } else {
            inputField.setAttribute("type", "password");
          }
        }
      });
    }
    
  }
});

function validateForm(form){
  const requiredFormField = [...form.querySelectorAll('input[name="customer[first_name]"], input[name="customer[email]"], input[name="customer[password]"]')];
  let errorCount = 0;
  if(requiredFormField.length){
    requiredFormField.forEach(field => {
      const fieldValue = field.value.trim();
      field.closest('.field-grp').classList.remove('error-active');
      if(!fieldValue.length){
        field.closest('.field-grp').classList.add('error-active');
        errorCount += 1;
      }
    });
  }
  if(errorCount === 0){
   form.submit();
  }else{
    return false;
  }
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !window.DesignMode) return;
  try {
    

  document.addEventListener("DOMContentLoaded", () => {
    //close popup function
    let closeBtn = document.querySelector('.newsletter-popup-main [data-close]');
    if(closeBtn){
      closeBtn.addEventListener('click', function(e){
        e.preventDefault();
        document.body.classList.remove('newsletter-open');
        localStorage.setItem('popup:opened:time',new Date().getTime());
        createCookie('theme:popup:opened', "true", 30);
        deletePopup();
      });
    }

    let popupForm = document.querySelector('.newsletter-popup-main [data-newsletter-form]');
    if(popupForm){
      popupForm.addEventListener('submit',function(){
        localStorage.setItem('popup:opened:time',new Date().getTime());
        createCookie('theme:popup:opened', "true", 30);
      });
    }
    
    newsletterInit();
  });

  function deletePopup(){
    var element = document.querySelector(".newsletter-popup-wrapper");
    if (element) {
      element.parentNode.removeChild(element);
      var scripts = document.querySelectorAll('script[src*="embed/embed.js"]');
      scripts.forEach(function(script) {
        script.parentNode.removeChild(script);
      });
      
      // Create and append the new script element
      let brandbotScript = document.createElement("script");
      brandbotScript.setAttribute("src", "https://assets.brandbot.com/forms/embed/embed.js?id=r1hpdc");
      document.body.appendChild(brandbotScript);

    }
  }
  
  function newsletterInit(){
    let popupSettings = JSON.parse(document.querySelector('.newsletter-popup-main [data-section-settings]').dataset.sectionSettings || '{}');
    
    if(Object.keys(popupSettings).length){
    
      var isPopopOpend = readCookie('theme:popup:opened');
      const now = new Date().getTime();
      const delaySeconds = +popupSettings.delay_seconds*1000;
      const isShowOnlyIndexPage = popupSettings.show_only_home_page;
    
      if (isPopopOpend || isPopopOpend == "true") {
        //console.log('alredy opend >>');
        //Popup close by customer or customer submited the form
        //Cheked if repeat popup enable
        //If enable, checked repeat popup duration
        const isRepeatPopupEnable = popupSettings.is_repeat_popup;
        if(isRepeatPopupEnable == false) return;

        const cookieDuration = Number(popupSettings.repeat_popup_duration);
        const getPoupopLastOpenTime = localStorage.getItem('popup:opened:time');
        const calculatedDate = (+getPoupopLastOpenTime)+(cookieDuration*86400000);
    
        if(new Date().getTime() > calculatedDate){
          //show popup again
          //console.log('open agian >>');
          setTimeout(() => {
            if(isShowOnlyIndexPage){
              if(document.body.classList.contains('template-index')){
                document.body.classList.add('newsletter-open');
                localStorage.setItem('popup:opened:time',new Date().getTime());
                createCookie('theme:popup:opened', "true", 30);
              }
            }else{
              document.body.classList.add('newsletter-open');
              localStorage.setItem('popup:opened:time',new Date().getTime());
              createCookie('theme:popup:opened', "true", 30);
            }
          }, delaySeconds);
        }else{
          //return from here
          //console.log('time remain to open >>');
          document.body.classList.remove('newsletter-open');
          deletePopup();
          return;
        }
    
      }else{
        //console.log('first time opend >>')
        setTimeout(() => {
          if(isShowOnlyIndexPage){
            if(document.body.classList.contains('template-index')){
              document.body.classList.add('newsletter-open');  
            }
          }else{
            document.body.classList.add('newsletter-open');
          }
        }, delaySeconds);
      }
    }
    
  }

  function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  }
  
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  
  function eraseCookie(name) {
    createCookie(name,"",-1);
  }
  

  } catch(e) { console.error(e); }
})();
      })();
